import { render, staticRenderFns } from "./g-box-personnel.vue?vue&type=template&id=7cebeff6&scoped=true&"
import script from "./g-box-personnel.vue?vue&type=script&lang=js&"
export * from "./g-box-personnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cebeff6",
  null
  
)

export default component.exports